import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityByProductResponse, ProfitabilityCommonFilters } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProfitabilityByProduct = (filters: ProfitabilityCommonFilters | undefined, enabled = true) => {
  return useQuery<ProfitabilityByProductResponse, Error>({
    queryKey: ['profitability', 'by-product', filters],
    queryFn: () => adapter.getByProduct(filters),
    enabled,
    staleTime: 60 * 1000,
  });
};
